import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { useLang } from "@/i18n";
import { HOME_COPY as C } from "@/data/homeContent";

export const HomeNewsletter = () => {
  const { t, lang } = useLang();
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [state, setState] = useState("idle");
  const submit = async (event) => {
    event.preventDefault();
    if (!consent || state === "loading") return;
    setState("loading");
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter`, { email: email.trim(), consent: true, source: "home", lang });
      setState("success");
    } catch { setState("error"); }
  };
  return <div className="rh-newsletter" data-testid="home-newsletter">
    <h3>{t(C.footerNewsletter)}</h3><p>{t(C.newsletterText)}</p>
    {state === "success" ? <p role="status" data-testid="home-newsletter-success" className="rh-newsletter-success">{t(C.newsletterSuccess)}</p> : <form onSubmit={submit} data-testid="home-newsletter-form">
      <div className="rh-newsletter-field">
        <label htmlFor="home-newsletter-email" className="sr-only">{t(C.email)}</label>
        <input id="home-newsletter-email" data-testid="home-newsletter-email" type="email" autoComplete="email" placeholder={t(C.email)} required value={email} onChange={(e) => setEmail(e.target.value)} disabled={state === "loading"} />
        <button type="submit" disabled={!consent || state === "loading"} aria-label={t(C.subscribe)} data-testid="home-newsletter-submit">{state === "loading" ? <Loader2 size={19} className="animate-spin" /> : <ArrowRight size={22} strokeWidth={1.2} />}</button>
      </div>
      <div className="rh-newsletter-consent"><Checkbox id="home-newsletter-consent" data-testid="home-newsletter-consent" checked={consent} onCheckedChange={(value) => setConsent(value === true)} disabled={state === "loading"} /><label htmlFor="home-newsletter-consent">{t(C.consent)} <Link to="/legal/privacidad" target="_blank" data-testid="home-newsletter-privacy">{t(C.privacy)}</Link>.</label></div>
      {state === "error" && <p role="alert" data-testid="home-newsletter-error" className="rh-newsletter-error">{t(C.newsletterError)}</p>}
    </form>}
  </div>;
};